/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ContactDeliveryMethod } from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { assign } from 'lodash';
import { ContactCommunity } from '../../resources/model/contact-details-fincance-company.model';
import { ContactDetailsFinanceCompanyCommonFormState } from './contact-details-finance-company-common-form.service';

@Component({
  selector: 'gh-contact-details-finance-company-common-tab',
  template: require('./contact-details-finance-company-common-tab.component.html'),
})
export class ContactDetailsFinanceCompanyCommonTabComponent implements OnInit {
  deliveryMethods: EnumDictionary<ContactDeliveryMethod>;
  communities: ContactCommunity[];

  constructor(private route: ContextRoute,
              public form: ContactDetailsFinanceCompanyCommonFormState) {
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  onUpdateBilling(): void {
    this.form.updateBilling();
  }
}
